<template>
  <v-menu v-model="dateMenu" transition="scale-transition" :close-on-content-click="false">

    <template v-slot:activator="{ props }">
      <v-text-field :variant="variant" :rules="rules" :label="label" :placeholder="placeholder"
        :prepend-inner-icon="prependInnerIcon" v-model="value" v-bind="props"></v-text-field>
    </template>
    <v-locale-provider locale="ru">
      <v-date-picker :min="min" :max="max" v-model="datePickerValue" hide-header @update:modelValue="dateMenu = false"></v-date-picker>
    </v-locale-provider>
  </v-menu>
</template>

<script>
import { useDate } from "vuetify"
import { isDate } from "./helpers";
export default {
  emits: ["update:modelValue"],
  data() {
    return {
      dateMenu: false,
      datePickerValue: [],
      dateFormatter: false
    };
  },
  //лень переписывать все свойства, если надо -вперед
  props: {
    label: {
      type: String,
      default: "",
    },
    min: {
      default: "",
    },
    max: {
      default: "",
    },
    prependInnerIcon: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "dd.mm.yyyy",
    },
    variant: {
      type: String,
      default: "filled",
    },
    rules: {
      type: Array,
      default: [
        (value) => {
          return !!isDate(value) || "Некорректная дата"
        },
      ],
    },
    modelValue: {
      required: true,
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        let date = isDate(value);
        if (date) {
          this.datePickerValue = date;
        }
        this.$emit("update:modelValue", value);
      },
    },
  },
  created() {
    this.dateFormatter = useDate();
  },
  watch: {
    datePickerValue: function (newVal, oldVal) {
      if (newVal.toString() == oldVal.toString()) {
        return
      }

      if (!newVal) {
        this.value = "";
        return
      }

      const [m, d, y] = this.dateFormatter
        .format(this.datePickerValue, "keyboardDate")
        .split("/");

      this.value = [d, m, y].join(".");
    }
  },
};
</script>
